import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';

import Checkbox from 'ati-ui-react/components/Checkbox';
import Badge from 'ati-ui-react/components/Badge';
import setUrlParam from 'utils/setUrlParam';

import { WithLizingStyles, WithLizingBadgeStyles } from './WithLizingStyles';

const WithLizing = observer(() => {
  const {
    findTrucksStore: {
      fields: { with_lizing },
      updateCheckBox,
    },
  } = useStores();

  return (
    <WithLizingStyles>
      <Checkbox
        label="Одобрен лизинг"
        onChange={() => {
          updateCheckBox({ field: 'with_lizing', value: !with_lizing });
          setUrlParam({ field: 'with_lizing', value: !with_lizing });
        }}
        checked={with_lizing}
        size="small"
      />
      <WithLizingBadgeStyles>
        <Badge mini color="green" className="badge">
          NEW
        </Badge>
      </WithLizingBadgeStyles>
    </WithLizingStyles>
  );
});

export default WithLizing;
